var map = {
	"./approval.svg": 6727,
	"./approvala.svg": 4578,
	"./arrow.svg": 130,
	"./arrowa.svg": 3538,
	"./classify.svg": 3260,
	"./classifya.svg": 1651,
	"./comment.svg": 1933,
	"./commenta.svg": 3721,
	"./counselor.svg": 1173,
	"./counselora.svg": 1310,
	"./course.svg": 305,
	"./coursea.svg": 8334,
	"./evaluation.svg": 8859,
	"./evaluationa.svg": 9019,
	"./good.svg": 5218,
	"./gooda.svg": 6533,
	"./log.svg": 9831,
	"./loga.svg": 2111,
	"./logo.svg": 247,
	"./order.svg": 7798,
	"./ordera.svg": 2765,
	"./qa.svg": 8717,
	"./qaa.svg": 7705,
	"./reservation.svg": 8296,
	"./reservationa.svg": 4080,
	"./setup.svg": 9293,
	"./setupa.svg": 8553,
	"./slider.svg": 5467,
	"./slidera.svg": 7896,
	"./title.svg": 9865,
	"./titlea.svg": 3362,
	"./user.svg": 7930,
	"./usera.svg": 702
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 956;